import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface ProgresoProps extends HTMLAttributes<HTMLDivElement> {
  /** 0 a 100. Se recorta a ese rango. */
  valor: number;
  tono?: "primary" | "success" | "warning" | "destructive";
}

const TONOS: Record<NonNullable<ProgresoProps["tono"]>, string> = {
  primary: "bg-primary",
  success: "bg-success",
  warning: "bg-warning",
  destructive: "bg-destructive",
};

/** Barra de progreso determinada (importacion de listas, remitos). */
export function Progreso({
  valor,
  tono = "primary",
  className,
  ...props
}: ProgresoProps): JSX.Element {
  const recortado = Math.min(100, Math.max(0, Math.round(valor)));
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={recortado}
      className={cn("h-1.5 w-full overflow-hidden rounded-full bg-muted", className)}
      {...props}
    >
      <div
        className={cn("h-full rounded-full transition-[width] duration-200", TONOS[tono])}
        style={{ width: `${recortado}%` }}
      />
    </div>
  );
}
